import { Box, FormControl, IconButton, InputAdornment, MenuItem, Popover, Select, TextField, Typography } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import CommonTypo from "../../components/CommonTypo";
import { insightsService } from "../../services/insightsService";
import { UserTypeContext } from "../../context/userStatus";
import moment from "moment";
import ArrowUp from "../../assets/images/icon/arrow_up";
import { ArrowUpNew } from "../../assets/images/icon/ArrowDownGreenNew";
import Calendar from "../../assets/images/icon/Calendar";
import { DatePicker, LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import typography, { pxToRem } from "../../theme/typography";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import insightsProgressStyles from "./insightsClasses";
import NewButton from "../../components/NewButton";
import ReactApexChart from "react-apexcharts";
import ChartSideBox from "./common/chartSideBox";
dayjs.extend(customParseFormat);
const nearestValueOutcome = (val, influenceItem) => {
  let arr = [];
  if (
    influenceItem.outcomeId &&
    influenceItem.options.length &&
    influenceItem.options[Math.round(val) - 1]
  ) {
    return influenceItem.options[Math.round(val) - 1].colorCode;
  }
  if (influenceItem?.options && influenceItem?.options.length) {
    arr = [...influenceItem?.options].map((it) => it.score);
  }
  const returnVal =
    arr.reduce(
      (p, n) => (Math.abs(p) > Math.abs(n - val) ? n - val : p),
      Infinity
    ) + val;
  if (influenceItem?.options && influenceItem?.options.length) {
    const foundIndexOfValue = influenceItem?.options.findIndex(
      (it) => it.score === returnVal
    );
    if (foundIndexOfValue > -1) {
      return influenceItem?.options[foundIndexOfValue]?.colorCode;
    }
  }
  return false;
};
const ArrowIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1090_2767)">
    <path d="M6.175 12.8418L10 9.02513L13.825 12.8418L15 11.6668L10 6.6668L5 11.6668L6.175 12.8418Z" fill="#656565" />
  </g>
</svg>

const CheckCircle = () => <span className="hide-element"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.9974 6.00244L10.9975 6.00258C11.0631 6.0679 11.1151 6.14552 11.1506 6.23099C11.1861 6.31645 11.2043 6.40808 11.2043 6.50063C11.2043 6.59317 11.1861 6.6848 11.1506 6.77026C11.1151 6.85573 11.0631 6.93335 10.9975 6.99867L10.9975 6.99873L7.49748 10.4987L7.49742 10.4988C7.4321 10.5643 7.35448 10.6163 7.26902 10.6518C7.18355 10.6873 7.09192 10.7056 6.99938 10.7056C6.90684 10.7056 6.81521 10.6873 6.72974 10.6518C6.64427 10.6163 6.56665 10.5643 6.50133 10.4988L6.50127 10.4987L5.00127 8.99873C4.93586 8.93332 4.88397 8.85566 4.84857 8.7702C4.81317 8.68473 4.79495 8.59313 4.79495 8.50062C4.79495 8.40812 4.81317 8.31652 4.84857 8.23105C4.88397 8.14559 4.93586 8.06793 5.00127 8.00252C5.06669 7.93711 5.14434 7.88522 5.22981 7.84982C5.31527 7.81442 5.40687 7.7962 5.49938 7.7962C5.59188 7.7962 5.68348 7.81442 5.76895 7.84982C5.85441 7.88522 5.93207 7.93711 5.99748 8.00252L5.9975 8.00254L6.96688 8.97067L7.00003 9.00377L7.03315 8.97064L10.0025 6.00069C10.0679 5.93543 10.1455 5.8837 10.231 5.84847C10.3164 5.81323 10.4079 5.79518 10.5003 5.79535C10.5927 5.79551 10.6842 5.81388 10.7695 5.84942C10.8548 5.88496 10.9322 5.93695 10.9974 6.00244ZM13.2969 8.00005V8C13.2969 6.95238 12.9862 5.92828 12.4042 5.05721C11.8222 4.18615 10.9949 3.50723 10.027 3.10633C9.05915 2.70542 7.99413 2.60052 6.96663 2.8049C5.93914 3.00928 4.99533 3.51376 4.25455 4.25454C3.51377 4.99532 3.00929 5.93914 2.80491 6.96663C2.60052 7.99412 2.70542 9.05915 3.10633 10.027C3.50724 10.9949 4.18615 11.8222 5.05722 12.4042C5.92828 12.9862 6.95238 13.2969 8 13.2969H8.00005C9.4044 13.2954 10.7508 12.7368 11.7438 11.7438C12.7368 10.7508 13.2954 9.40439 13.2969 8.00005ZM14.7031 8.00005C14.7031 9.32579 14.31 10.6217 13.5734 11.7241C12.8369 12.8264 11.79 13.6855 10.5652 14.1929C9.34034 14.7002 7.99257 14.833 6.69229 14.5743C5.39201 14.3157 4.19763 13.6773 3.26018 12.7398C2.32273 11.8024 1.68432 10.608 1.42568 9.30771C1.16704 8.00744 1.29978 6.65966 1.80712 5.43482C2.31447 4.20999 3.17362 3.1631 4.27595 2.42656C5.37826 1.69001 6.67423 1.29688 7.99998 1.29688C9.77715 1.29885 11.481 2.00571 12.7376 3.26237C13.9943 4.51903 14.7012 6.22286 14.7031 8.00005Z" fill="#3E4240" stroke="#3E4240" stroke-width="0.09375" />
</svg>
</span>

const ArrowDown = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1090_701)">
    <path d="M13.825 6.6665L10 10.4832L6.175 6.6665L5 7.8415L10 12.8415L15 7.8415L13.825 6.6665Z" fill="#656565" />
  </g>
  <defs>
    <clipPath id="clip0_1090_701">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>


const Chart = ({ selectOutcome, outcomeData, isDarkMode = false }) => {
  const { state: IUserTypeState } =
    useContext(UserTypeContext);

  const selectRef = useRef(null);
  const [tooltip, setTooltip] = useState({ visibility: 'hidden', x: 0, y: 0, text: '' });
  const [statisData, setstatisData] = useState([])
  const [selectedRange, setSelectedRange] = useState("CURRENT_MONTH")
  const [resultData, setResultData] = useState<any>({})
  const [startDate, setStartDate] = useState(null)
  const [MenuOpen, setMenuOpen] = useState(false)
  const [endDate, setEndDate] = useState(null)
  const selectedOutcome = outcomeData.find(it => it.outcomeId === selectOutcome)
  const getTrendChart = (startDate, endDate) => {
    const userId: any = {
      "outcomeId": selectOutcome,
      "dateType": selectedRange,
      "from": startDate,
      "to": endDate
    };
    insightsService
      .getTrend(userId, IUserTypeState.token)
      .then((data: any) => {
        console.log("data", data);
        setResultData(data)
        const statisDa = []
        for (let index = 0; index < (data?.resultCurrent || []).length; index++) {
          const element = (data?.resultCurrent || [])[index];
          if (["CURRENT_QUARTER", "PREVIOUS_QUARTER"].includes(selectedRange)) {
            statisDa.push({
              date: "Week " + element.week,
              // month: moment(element?.date).format("MMM"),
              value: element.avg
            })
          } else if (["CURRENT_YEAR", "PREVIOUS_YEAR"].includes(selectedRange)) {
            statisDa.push({
              date: element.monthName.slice(0, 3),
              // month: moment(element?.date).format("MMM"),
              value: element.avg
            })
          } else {
            statisDa.push({
              date: moment(element?.date).format("DD"),
              month: moment(element?.date).format("MMM"),
              value: element.index
            })
          }

        }
        setstatisData(statisDa)
      })
      .catch((error) => {
        console.log("User profile Error", error);
      });
  }

  useEffect(() => {
    if (selectedRange === "CURRENT_TWO_WEEKS") {
      const startDate = moment().subtract(14, 'days').startOf('day'); // Start of the week
      const endDate = moment().subtract(1, 'day').endOf("day"); // 13 days later, covering a 2-week period
      getTrendChart(startDate.format("MM-DD-YYYY"), endDate.format("MM-DD-YYYY"))
    }
    if (["CURRENT_MONTH", "PREVIOUS_MONTH"].includes(selectedRange)) {
      getTrendChart(moment().startOf("month").format("MM-DD-YYYY"), moment().endOf("month").format("MM-DD-YYYY"))
    }
    if (["CURRENT_QUARTER", "PREVIOUS_QUARTER"].includes(selectedRange)) {
      const today = moment();
      const currentYear = today.year();
      const currentMonth = today.month();

      let quarterStartMonth;
      let quarterEndMonth;

      if (currentMonth < 3) {
        quarterStartMonth = 0;  // Q1 starts in January
        quarterEndMonth = 2;    // Q1 ends in March
      } else if (currentMonth < 6) {
        quarterStartMonth = 3;  // Q2 starts in April
        quarterEndMonth = 5;    // Q2 ends in June
      } else if (currentMonth < 9) {
        quarterStartMonth = 6;  // Q3 starts in July
        quarterEndMonth = 8;    // Q3 ends in September
      } else {
        quarterStartMonth = 9;  // Q4 starts in October
        quarterEndMonth = 11;   // Q4 ends in December
      }

      // Define the start and end of the current quarter
      const quarterStartDate = moment([currentYear, quarterStartMonth]).startOf('day');
      const quarterEndDate = moment([currentYear, quarterEndMonth]).endOf('month').endOf('day');

      // Adjust the end date if it's beyond today
      const adjustedEndDate = quarterEndDate.isAfter(today) ? today : quarterEndDate;
      getTrendChart(quarterStartDate.format("MM-DD-YYYY"), adjustedEndDate.format("MM-DD-YYYY"))
    }
    if (["CURRENT_YEAR", "PREVIOUS_YEAR"].includes(selectedRange)) {
      getTrendChart(moment().startOf("year").format("MM-DD-YYYY"), moment().endOf("year").format("MM-DD-YYYY"))
    }

  }, [selectedRange, selectOutcome])
  useEffect(() => {
    getTrendChart(moment().startOf("month").format("MM-DD-YYYY"), moment().endOf("month").format("MM-DD-YYYY"))
  }, [selectOutcome])
  console.log("selectOutcome", selectedOutcome, outcomeData, selectOutcome);

  const handleMouseOver = (event, text, x, y) => {
    console.log("statisDa", event, text);

    setTooltip({
      visibility: 'visible',
      x: x + 10, // Offset to prevent overlap with the column
      y: y - 10, // Position above the column
      text: `${text}`
    });
  };

  const handleMouseMove = (event) => {
    // setTooltip((prev) => ({
    //   ...prev,
    //   x: event.clientX,
    //   y: event.clientY - 10,
    // }));
  };

  const handleMouseOut = () => {
    setTooltip({ visibility: 'hidden', x: 0, y: 0, text: '' });
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const renderMenuItem = (value, title) => (
    <MenuItem value={value} sx={{
      padding: "12px !important",
      fontSize: `${pxToRem(14)} !important`,
      fontWeight: selectedRange === value ? `600 !important` : `400 !important`,
      color: isDarkMode ? "var(--color-text-primary) !important" : "#3E4240 !important",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }}>{title}
      {selectedRange === value && <CheckCircle />}</MenuItem>
  )
  console.log("anchorEl", anchorEl);
  const [startshowPicker, setstartShowPicker] = useState(false)
  const [endshowPicker, setendShowPicker] = useState(false)
  return (
    <>
      <Box sx={{ flexGrow: 1, }}>
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",

        }}>
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            gap: "8px"
          }}>
            <CommonTypo size={24} color={isDarkMode ? "var(--color-text-primary) !important" : "#3E4240"} fontWeight={700} extraSx={{
              whiteSpace: "nowrap",
            }}>{(selectedOutcome && selectedOutcome.name ? selectedOutcome.name : "") + " trend"}</CommonTypo>
          </Box>
          <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
            <Select
              labelId="demo-simple-select-filled-label"
              id="demo-simple-select-filled"
              sx={{
                // padding: "16px, 12px, 16px, 16px",
                "&.MuiInputBase-root": {
                  height: "40px",
                  borderRadius: "20px",
                  padding: "16px 12px 16px 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  "&.Mui-focused": {
                    background: "#EEEEEE"
                  },
                  "&::before": {
                    borderBottom: "0px !important"
                  },
                  "&.MuiSelect-root:hover:not(.Mui-disabled):before": {
                    borderBottom: "0px",
                  },
                  "&::hover": {
                    borderBottom: "0px",
                    "&::before": {
                      borderBottom: "0px"
                    },
                  },
                  "&::after": {
                    borderBottom: "0px"
                  },
                  "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                    padding: "0px",
                    paddingRight: "0px !important",
                    color: isDarkMode ? "var(--color-text-primary) !important" : "#656565",
                    "&:focus": {
                      backgroundColor: "transparent"
                    },
                    "& .hide-element": {
                      display: "none"
                    }
                  }
                }
              }}
              ref={selectRef}
              value={selectedRange}
              onChange={(event) => {
                if (event.target.value === "CUSTOM") {
                  setAnchorEl(selectRef.current)
                }
                setSelectedRange(event.target.value)
              }}
              IconComponent={MenuOpen ? ArrowIcon : ArrowDown}
              MenuProps={{
                sx: {
                  "& .MuiPaper-root": {
                    borderRadius: "12px",
                    boxShadow: "0px 0px 64px 0px #190D1A1A",
                    width: "168px",
                  }
                }
              }}
              onOpen={() => setMenuOpen(true)}
              onClose={() => setMenuOpen(false)}
            >
              {[{
                value: "CURRENT_TWO_WEEKS",
                title: "Last 14 days"
              },
              {
                value: "PREVIOUS_MONTH",
                title: "Last month"
              },
              {
                value: "CURRENT_MONTH",
                title: "This month"
              },
              {
                value: "PREVIOUS_QUARTER",
                title: "Last quarter"
              },
              {
                value: "CURRENT_QUARTER",
                title: "This quarter"
              },
              {
                value: "PREVIOUS_YEAR",
                title: "Last year"
              },
              {
                value: "CURRENT_YEAR",
                title: "This year"
              },
              {
                value: "CUSTOM",
                title: "Custom"
              }].map(it => renderMenuItem(it.value, it.title))}
            </Select>
          </FormControl>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            sx={{
              '& .MuiPaper-root': {
                background: "#FFFFFF",
                boxShadow: "0px 0px 64px 0px #190D1A1A",
                borderRadius: "12px",
                width: "312px"
              }
            }}
          >
            <Box sx={{
              padding: "16px",
              borderRadius: "12px",

            }}>
              <Box sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px"
              }}>
                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }} onClick={() => {
                  handleClose()
                }}>
                  <Box sx={{
                    rotate: "270deg",
                    display: "flex",
                    alignItems: "center",
                    height: "16px",
                    width: "16px"
                  }}>
                    <ArrowUp color={isDarkMode ? "var(--color-text-primary) !important" : "#3E4240"} size="16" />
                  </Box>
                  <CommonTypo size={16} color={isDarkMode ? "var(--color-text-primary) !important" : "#3E4240"} fontWeight={400}>Back</CommonTypo>
                </Box>
                <DatePick name={"Starts"} selectedDate={startDate} setSelectedDate={setStartDate} showpicker={startshowPicker} setShowPicker={() => {
                  setstartShowPicker(true)
                  setendShowPicker(false)
                }}
                />
                <DatePick name={"Ends"} selectedDate={endDate} setSelectedDate={setEndDate} showpicker={endshowPicker} setShowPicker={() => {
                  setendShowPicker(true)
                  setstartShowPicker(false)
                }}
                />
                <NewButton extraSx={{
                  height: "40px"
                }} isDisabled={!startDate && !endDate} buttonText="Save" padding="16px" borderRadius="20px !important" fontWeight={600} typographySx={{
                  fontWeight: 600
                }} onClick={() => {
                  handleClose()
                  getTrendChart(dayjs(startDate).format("MM-DD-YYYY"), dayjs(endDate).format("MM-DD-YYYY"))
                }} />
              </Box>
            </Box>
          </Popover>
        </Box>
        <Box style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
          marginTop: "16px"
        }}>
          {/* <MyScrollableGraph statisData={statisData} tooltip={tooltip} handleMouseOver={handleMouseOver}
            handleMouseMove={handleMouseMove}
            handleMouseOut={handleMouseOut}
            selectedRange={selectedRange} /> */}
          <ChartExample statisData={statisData} selectedOutcome={selectedOutcome} isDarkMode={isDarkMode} />
          <ChartSideBox currentAvg={resultData?.avgResponse?.currentAvg || 0} percentageChange={resultData?.percentageChange || 0} selectedOption={selectedRange} isDarkMode={isDarkMode} />
        </Box>
      </Box>
    </>
  );
};

export default Chart;

const DatePick = ({
  name, selectedDate, setSelectedDate, showpicker, setShowPicker
}) => {
  const classes = insightsProgressStyles()
  const [popupvisible, setpopupvisible] = useState(false)


  return <Box display={"flex"} flexDirection={"column"} gap={"8px"} alignItems={"flex-start"} >
    <CommonTypo size={12} color="#656565" fontWeight={400}>{name}</CommonTypo>
    <LocalizationProvider dateAdapter={AdapterDayjs} >
      <TextField
        value={selectedDate ? selectedDate.format("DD MMM YYYY") : ""}
        onClick={(event) => {
          event.currentTarget.blur()
          setShowPicker(true)
        }}
        onFocus={(event) => event.currentTarget.blur()}
        sx={{
          width: "100%",
          "&.MuiTextField-root": {
            marginBottom: "0px !important",
          },
          "& .MuiOutlinedInput-root": {
            alignItems: "center",
            color: "#19442E",
            gap: "8px",
            borderRadius: "16px !important",
            border: "1px solid #F3F3F3",
            background: "#FFF",
            "& .MuiOutlinedInput-input": {
              padding: "16px 12px !important",
              color: "#19442E!important",
              '&::placeholder': {
                textTransform: "uppercase"
              },
            },
          },
        }}
      />
      {showpicker && (
        <StaticDatePicker
          value={selectedDate}
          onChange={(newValue) => {
            console.log("Selected date:", newValue);
            setSelectedDate(newValue);
          }}
          displayStaticWrapperAs="desktop"
          components={{
            SwitchViewButton: (buttonProps) => (
              <IconButton {...buttonProps}>
                <ArrowUpNew /> {/* Custom icon */}
              </IconButton>
            ),
          }}
          componentsProps={{
            actionBar: { sx: { display: "none" } }, // Hides the action toolbar
          }}
          className={classes.calendarClass}
          inputFormat="DD MMM YYYY"
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                width: "200px", // Set width to 200px
                "&.MuiTextField-root": {
                  marginBottom: "0px !important",
                },

                "& .MuiOutlinedInput-root": {
                  alignItems: "center",
                  color: "#19442E",
                  gap: "8px",
                  borderRadius: "16px !important",
                  border: "1px solid #F3F3F3",
                  background: "#FFF",
                  "& .MuiOutlinedInput-input": {
                    padding: "16px 12px !important",
                    color: "#19442E!important",
                    '&::placeholder': {
                      textTransform: "uppercase"
                    },
                  },
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    {null}
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      )}

    </LocalizationProvider>
  </Box>
}


const MyScrollableGraph = ({ statisData, tooltip, handleMouseOver, handleMouseMove, handleMouseOut, selectedRange }) => {
  let adjustRange = 30
  if (selectedRange === "CURRENT_QUARTER") {
    adjustRange = 60
  }
  if (selectedRange === "CURRENT_YEAR") {
    adjustRange = 60
  }
  let xSize = 0
  if (selectedRange === "CURRENT_QUARTER") {
    xSize = 0
  }
  if (selectedRange === "CURRENT_YEAR") {
    xSize = 1
  }
  const svgWidth = (25 + ((adjustRange) * (statisData.length + 1)) - 100) > 0
    ? selectedRange === "CURRENT_QUARTER" || selectedRange === "CURRENT_YEAR" ? 25 + ((adjustRange + xSize) * (statisData.length + 1))
      : 25 + ((adjustRange + xSize) * (statisData.length + 1)) - 100 : (25 + ((adjustRange + xSize) * (statisData.length + 1))); // Adjust the width based on the data length
  console.log("statisData", statisData, selectedRange);

  return (
    <div style={{ width: 'calc(100% - 300px)', minWidth: 'calc(100% - 300px)', overflowX: 'auto', overflowY: 'hidden' }} className="progress-chart">
      <svg width={svgWidth} height="330" xmlns="http://www.w3.org/2000/svg">
        <g fontSize="10" fill="#656565" fontWeight="400">

          {[...statisData].map((_, index) => (
            <>
              {_.date === "01" && selectedRange !== "CURRENT_QUARTER" && <text x={25 + (30 * (index + 1))} y="315">{_.month}</text>}
              <text key={index} x={(selectedRange === "CURRENT_YEAR" ? 30 : 25) + ((adjustRange + xSize) * (index + 1))} y="330" fontSize={"10"}>{_.date}</text>
            </>
          ))}
        </g>

        <g fontSize="10" fill="#656565" fontWeight="400">
          <text x="10" y="300">0</text>
          <text x="10" y="250">1</text>
          <text x="10" y="200">2</text>
          <text x="10" y="150">3</text>
          <text x="10" y="100">4</text>
          <text x="10" y="50">5</text>
        </g>

        <g fill="var(--color-new-main)">
          {statisData.map((data, index) => {
            const x = 20 + ((adjustRange + xSize) * (index + 1));
            const y = 300 - data.value * 50;
            return (
              <React.Fragment key={index}>
                <rect
                  x={x}
                  y={y}
                  width={selectedRange === "CURRENT_QUARTER" || selectedRange === "CURRENT_YEAR" ? "40" : "20"}
                  height={["NO_DATA", "NaN"].includes(data.value) ? 0 : data.value * 50}
                  rx="12"
                  ry="12"
                  onMouseOver={(e) => handleMouseOver(e, data.value, x, y)}
                  onMouseMove={handleMouseMove}
                  onMouseOut={handleMouseOut}
                />
              </React.Fragment>
            );
          })}
        </g>

        <g>
          <rect
            x={tooltip.x - 26 / 2}
            y={tooltip.y - 10}
            width="26"
            height="24"
            fill="#19442E"
            rx="4"
            ry="4"
            style={{
              opacity: '1',
              filter: 'drop-shadow(0px 4px 6px rgba(73, 102, 93, 0.18))'
            }}
            visibility={tooltip.visibility}
          />
          <text
            x={tooltip.x}
            y={tooltip.y + 4}
            fontFamily={typography.fontFamily}
            fontSize="16"
            fontWeight="500"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#FFFFFF"
            visibility={tooltip.visibility}
            style={{
              textAlign: 'center',
              background: '#FFFFFF',
              opacity: '1'
            }}
          >
            {tooltip.text}
          </text>
        </g>
        <line x1="40" y1="350" x2="780" y2="350" stroke="black" strokeWidth="0"></line>
      </svg>
    </div>
  );
};

const ChartExample = ({ statisData, selectedOutcome, isDarkMode = false }) => {
  const categories = []
  const seriesData = []
  for (let index = 0; index < statisData.length; index++) {
    const element = statisData[index];
    console.log("element", element);
    if (element.date) {
      categories.push(element.date)
    }

    if (element.value && !["NaN", "NO_DATA"].includes(element.value)) {
      let color = "var(--color-new-main)"
      if (selectedOutcome.outcomeId) {
        const newColor = nearestValueOutcome(element.value, selectedOutcome)
        if (newColor) {
          color = newColor
        }
      }
      seriesData.push({
        x: element.date,
        y: element.value,
        fillColor: color
      })
    } else {
      seriesData.push({
        x: element.date,
        y: 0,
      })
    }

  }
  const options = {

    series: [{
      name: '',
      data: seriesData
    }],
  };
  console.log("options", categories, options);

  return <div style={{
    width: "100%"
  }}>
    <ReactApexChart options={{
      chart: {
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 5,
          columnWidth: 16,
        }
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        marker: {
          show: false
        },
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const value = series[seriesIndex][dataPointIndex];
          return `
            <div class="custom-tooltip">
              <span class="tooltip-value">${value === 0.6 ? 0 : value}</span>
            </div>
          `;
        },
        cssClass: "custom-tooltip-chart",
        x: {
          show: false
        },
      },
      xaxis: {
        categories: categories,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        tooltip: {
          enabled: false,
        },
        ...(isDarkMode && {
          labels: {
            show: true,
            style: {
              colors: "var(--color-text-primary)",
            },
          },
        }),
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          show: false
        },
        max: 5,
        ...(isDarkMode && {
          labels: {
            show: true,
            style: {
              colors: "var(--color-text-primary)",
            },
          },
        }),
      },
      grid: {
        show: false
      },
      // fill: {
      //   colors: ["#ADE888"] // Array of colors
      // }
    }} series={options.series} type="bar" height={350} />
  </div>
}